import { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import './ReferralsDetails.scss'
import { BnpmPromoWinXModel } from 'BoostXpressAdmin/Model/bnpmPromoXModel'
import { ReferalXModel } from 'BoostXpressAdmin/Model/referalXModel'
import { bnpmPromoBXService } from 'BoostXpressAdmin/Services/bnpmPromoBXService'
import { formatString } from 'Helpers/formatString'
import backArrow from '../../../../../Assets/Icon/Users/back-arrow-detailed.svg'
import breadcrumbArrow from '../../../../../Assets/Icon/Referrals/breadcrumb-arrow.svg'
import { handleError } from 'Helpers'

const formatCurrency = (amount: number) => `₦${amount.toLocaleString()}`

const formatDateTime = (value?: string | null) => {
  if (!value) return '-'
  return new Date(value).toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: false,
  })
}

const BNPMReferralsDetails = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [win, setWin] = useState<BnpmPromoWinXModel | null>(null)

  useEffect(() => {
    let cancelled = false

    const loadDetails = async () => {
      if (!id) return

      setIsLoading(true)
      await bnpmPromoBXService.showWin(id).then(
        (res) => {
          if (cancelled) return
          setWin(res.data.data ?? null)
          setIsLoading(false)
        },
        (error) => {
          setIsLoading(false)
          handleError(error)
        },
      )
    }

    loadDetails()

    return () => {
      cancelled = true
    }
  }, [id])

  const totalAmountWon = win && (win.amountMajor ?? 0)

  const historyRows = useMemo(() => {
    if (win) {
      return [
        {
          id: win.resourceId,
          transactionAmount: win.order?.costMajor ?? 0,
          amountWon: win.amountMajor ?? 0,
          dateTime: win.createdAt,
        },
      ]
    }

    // if (!referral) return []

    // const rows = [
    //   {
    //     id: 'created',
    //     transactionAmount:
    //       referral.referredRewardMinor > 0
    //         ? referral.referredRewardMinor / 100
    //         : referral.referrerRewardMinor / 100,
    //     amountWon: referral.referrerRewardMinor / 100,
    //     dateTime: referral.createdAt,
    //   },
    // ]

    // if (referral.completedAt) {
    //   rows.push({
    //     id: 'completed',
    //     transactionAmount: referral.referrerRewardMinor / 100,
    //     amountWon: referral.referrerRewardMinor / 100,
    //     dateTime: referral.completedAt,
    //   })
    // }

    // return rows
  }, [win])

  return (
    <div className='bx-bnpm-details'>
      <div className='bx-bnpm-details__breadcrumb'>
        <button type='button' className='bx-bnpm-details__back' onClick={() => navigate(-1)}>
          <img src={backArrow} alt='Back' />
        </button>
        <div className='bx-bnpm-details__crumbs'>
          <Link to='/boostxpress/referrals' className='bx-bnpm-details__crumb-link'>
            BNPM Management
          </Link>
          <img src={breadcrumbArrow} alt='' />
          <span className='bx-bnpm-details__crumb-current'>BNPM Details</span>
        </div>
      </div>

      <div className='row g-4'>
        <div className='col-xl-6'>
          <section className='bx-bnpm-details__section'>
            <h3 className='bx-bnpm-details__section-title'>Customer Details</h3>
            <div className='bx-bnpm-details__info-card'>
              <div className='bx-bnpm-details__info-row'>
                <span>Customer Name</span>
                <strong>
                  {win?.user?.firstName ?? ''} {win?.user?.lastName ?? ''}
                </strong>
              </div>
              <div className='bx-bnpm-details__info-row'>
                <span>Customer Email</span>
                <strong>{win?.user?.email?.trim() ?? '-'}</strong>
              </div>
              <div className='bx-bnpm-details__info-row'>
                <span>Date</span>
                <strong>{formatDateTime(win?.createdAt)}</strong>
              </div>

              {/* <div className='bx-bnpm-details__info-row'>
                <span>{win ? 'Win Type' : 'No of Cycles'}</span>
                <strong>{win ? formatString(win.winType) : referral ? cycleCount : '-'}</strong>
              </div> */}
              {/* <div className='bx-bnpm-details__info-row'>
                <span>{win ? 'Order Reference' : 'Transaction Count'}</span>
                <strong>
                  {win
                    ? (win.order?.referenceNumber ?? '-')
                    : referral
                      ? `${transactionCount} of ${cycleCount}`
                      : '-'}
                </strong>
              </div> */}
            </div>
          </section>
        </div>

        <div className='col-xl-6'>
          <section className='bx-bnpm-details__section'>
            <h3 className='bx-bnpm-details__section-title'>BNPM Amount</h3>
            <div className='bx-bnpm-details__amount-card'>
              <span>{formatCurrency(win?.amountMajor ?? 0)}</span>
            </div>
          </section>
        </div>
      </div>

      <section className='bx-bnpm-details__section bx-bnpm-details__section--table'>
        <h3 className='bx-bnpm-details__section-title'>Transaction History</h3>

        <div className='bx-bnpm-details__table-shell'>
          <div className='table-responsive'>
            <table className='bx-bnpm-details__table'>
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Customer Name</th>
                  <th>Transaction Amount</th>
                  <th>BNPM Amount</th>
                  <th>Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={4} className='bx-bnpm-details__table-cell text-center'>
                      Loading details...
                    </td>
                  </tr>
                ) : historyRows?.length === 0 ? (
                  <tr>
                    <td colSpan={4} className='bx-bnpm-details__table-cell text-center'>
                      No transaction history available
                    </td>
                  </tr>
                ) : (
                  historyRows?.map((row, index) => (
                    <tr key={row.id}>
                      <td className='bx-bnpm-details__table-cell'>{index + 1}</td>
                      <td className='bx-bnpm-details__table-cell'>
                        {win?.user?.firstName ?? ''} {win?.user?.lastName ?? ''}
                      </td>
                      <td className='bx-bnpm-details__table-cell'>
                        {formatCurrency(row.transactionAmount)}
                      </td>
                      <td className='bx-bnpm-details__table-cell'>
                        {/* {formatCurrency(row.amountWon)} */}
                        {formatCurrency(win?.amountMajor ?? 0)}
                      </td>
                      <td className='bx-bnpm-details__table-cell'>
                        {formatDateTime(row.dateTime)}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  )
}

export default BNPMReferralsDetails
